import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import React from 'react'

import { ChevronLeftIcon, ChevronRightIcon } from '../../../icons'
import Typography from '../../atoms/typography'
import BasicCalendar, { BasicCalendarProps } from '../basic-calendar'
import { MonthlyCalendarEvent } from './types'

type MonthlyCalendarProps = Omit<BasicCalendarProps, 'header'> & {
  events: MonthlyCalendarEvent[]
}

const MonthlyCalendar: React.FC<MonthlyCalendarProps> = (props) => {
  return (
    <BasicCalendar
      className="border border-grey-light px-3 py-4 rounded-xl"
      header={(data) => (
        <div className="flex items-center justify-between">
          <div className="cursor-pointer border border-grey-light rounded p-1">
            <ChevronLeftIcon color={tailwindColors.grey.DEFAULT} onClick={data.onPrevMonthClick} />
          </div>
          <Typography variant="body-medium">
            {data.month} {data.year}
          </Typography>
          <div className="cursor-pointer border border-grey-light rounded p-1">
            <ChevronRightIcon
              color={tailwindColors.grey.DEFAULT}
              onClick={data.onNextMonthClick}
            />
          </div>
        </div>
      )}
      {...props}
    />
  )
}

export default MonthlyCalendar
